/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ImportWarehousePOs from './Components/ImportWarehousePos';
import ImportSupplierPOs from './Components/ImportSupplierPos';

function Import() {
  return (
    <>
      <Row>
        <Col className="py-4">
          <ImportSupplierPOs />
        </Col>
      </Row>
      <Row>
        <Col className="py-4">
          <ImportWarehousePOs />
        </Col>
      </Row>
    </>
  );
}

export default Import;
